import React from "react";

interface ProjectDescriptionProps {
  description: string;
}

const ProjectDescription: React.FC<ProjectDescriptionProps> = ({
  description,
}) => {
  return (
    <p className="text-gray-700 leading-relaxed">
      {description}
    </p>
  );
};

export default ProjectDescription;
